import { Application } from "stimulus";
import * as Honeybadger from '@honeybadger-io/js';

export const setupStimulusErrorHandler = (application: Application) => {
  application.handleError = (error, message, detail) => {
    console.error(message, detail, error);
    Honeybadger.notify(error)
  }
}
